import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'bulk-operations-core.toolbar.use-bulk-delete-action.title',
		defaultMessage: 'Delete {count, plural, one {# issue} other {# issues}}?',
		description: 'Title of the confirmation modal asking if user really wants to delete issues',
	},
	deleteButton: {
		id: 'bulk-operations-core.toolbar.use-bulk-delete-action.detele-button',
		defaultMessage: 'Delete',
		description:
			'Text on delete button in the bulk operations floating toolbar to delete multiple issues',
	},
});
